define("analytics-resources/utils/charts/chart-utils", ["exports", "@ember/utils", "analytics-resources/types/chart-types", "moment-timezone", "later/utils/time-format"], function (_exports, _utils, _chartTypes, _momentTimezone, _timeFormat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.computeColorIndex = computeColorIndex;
  _exports.generateXAxisLabels = generateXAxisLabels;
  _exports.getTickPositions = getTickPositions;
  _exports.interpolateData = void 0;
  _exports.showEmptyChart = showEmptyChart;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils",0,"analytics-resources/types/chart-types",0,"moment-timezone",0,"later/utils/time-format"eaimeta@70e063a35619d71f
  function showEmptyChart(chartState) {
    return chartState !== _chartTypes.ChartState.Data && chartState !== _chartTypes.ChartState.PartialData;
  }
  function getTickPositions(chartData, timeZone) {
    if ((0, _utils.isEmpty)(chartData) || !timeZone) {
      return undefined;
    }
    return chartData.map(_ref => {
      let [time] = _ref;
      const currentMoment = (0, _momentTimezone.default)(time).tz(timeZone).startOf('day').unix();
      return _timeFormat.convert.seconds(currentMoment).toMilliseconds();
    });
  }
  function generateXAxisLabels(timeZone, chartTimeScale) {
    return {
      formatter() {
        const value = typeof this.value === 'string' ? Number(this.value) : this.value;
        const momentTime = _momentTimezone.default.tz(value, timeZone);
        return chartTimeScale === _chartTypes.TimeScale.Hour ? momentTime.format('h A') : momentTime.format('MMM D');
      }
    };
  }
  function computeColorIndex(numberOfColorGradientSteps, chartData, currentRank) {
    // Note: off by 1 is to avoid highcharts-social-listening-series-0
    const interval = (numberOfColorGradientSteps - 1) / chartData.length;
    return Math.floor(currentRank * interval) + 1;
  }
  const sortDataByX = data => {
    return [...data].sort((a, b) => a[0] - b[0]);
  };
  const linearInterpolate = (x1, y1, x2, y2, x) => {
    return y1 + (x - x1) * (y2 - y1) / (x2 - x1);
  };
  const interpolateDataPoints = (data, xSpacing) => {
    const result = [];
    for (let i = 0; i < data.length - 1; i++) {
      const start = data[i];
      const end = data[i + 1];
      if (start[1] !== null && end[1] !== null) {
        result.push(start);
        let nextX = start[0] + xSpacing;
        while (nextX < end[0]) {
          const interpolatedY = linearInterpolate(start[0], start[1], end[0], end[1], nextX);
          result.push([nextX, interpolatedY]);
          nextX += xSpacing;
        }
      }
    }
    // Note: Push the last point if not added
    if (!result.find(_ref2 => {
      let [x] = _ref2;
      return x === data[data.length - 1][0];
    })) {
      result.push(data[data.length - 1]);
    }
    return result;
  };
  const interpolateData = (data, xSpacing) => {
    if (data.length < 2) {
      return data;
    }
    const sortedData = sortDataByX(data);
    return interpolateDataPoints(sortedData, xSpacing);
  };
  _exports.interpolateData = interpolateData;
});